import React, { Component } from 'react';
import { getFileDetail } from '../../../../api/api';
import { File } from '../../files/create-directory';

const apiBase = '/v1';

const isImage = filename => (filename || '').match(/.(jpg|jpeg|png|gif)$/i);

class FileCell extends Component {
  constructor(props) {
    super(props);
    this.loadFile = this.loadFile.bind(this);
    this.state = { file: null, error: null };
    if (props.value) {
      this.loadFile();
    }
  }
  async loadFile() {
    try {
      const file = await getFileDetail(this.props.value);
      this.setState({ file, error: null });
    } catch (err) {
      this.setState({ file: null, error: err });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value === this.props.value) return;
    this.loadFile();
  }
  render() {
    const { value } = this.props;
    if (!this.state.file) return false;

    const activeFile = new File(this.state.file);
    return (
      <div className="file-cell">
        {isImage(activeFile.name) &&
          <img src={`${apiBase}/files/${encodeURIComponent(value)}`} />}
        <label>{activeFile.name}</label>
      </div>
    );
  }
}

export default FileCell;



// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/FileCell.js